import { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Routes } from 'app/config/routes/consts';
import { ExtensionsEnum } from 'entities/Extensions/enums';
import { AssertionWidget } from './ui/AssertionSets';
import { CustomOutputFileWidget } from './ui/CustomOutputFile';
import { WarehouseWidget } from './ui/Warehouse';
import InboundEmail from './ui/inbound-email';

export const ExtensionsDetailsWidget: FC = () => {
	const { exName } = useParams();

	if (exName === ExtensionsEnum.assertions_sets) {
		return <AssertionWidget />;
	}

	if (exName === ExtensionsEnum.custom_output_file) {
		return <CustomOutputFileWidget />;
	}

	if (exName === ExtensionsEnum.warehouse) {
		return <WarehouseWidget />;
	}

	if (exName === ExtensionsEnum.inbound_email) {
		return <InboundEmail />;
	}

	return <Navigate to={Routes.extensions} />;
};
